export const environment = {
	production: true,
	configFile: '/assets/json/config.json',
	versionsFile: '/assets/json/versions.json'
};
